const BaseCategoryPage = require('base/category-page');
const Server = require('helper/server');

const agentListTpl = Handlebars.templates['templates/category-agent-list-tpl'];

class OrgCategory extends BaseCategoryPage {
  search () {
    const requestData = {
      pageNo: this.pageNo,
      pageSize: this.pageSize,
      regDist: 450899
    };
    if (this.query.get('keyword')) {
      requestData.fullName = this.query.get('keyword');
    }
    this.renderAgentList(requestData);
  }

  renderAgentList (payload) {
    Server.getAgentList({ data: payload })
      .done(({ total = 0, data = [] }) => {
        const { articleModelFile } = this.selectedTreeNode;
        if (data && data instanceof Array) {
          data.forEach((item, index) => {
            item.index = index + 1;
          });
        }
        this.$content.find('.block__content').html(agentListTpl({
          _DATA_: data,
          _pageSize_: this.pageSize || '15',
          _PATH_: articleModelFile
        }));
        this.$el.find('.block__content .total').text(total || 0);
        this.initPagination(total);
      });
  }

  selectTreeNode (e, { instance }) {
    this.renderBreadcrumb(instance);
    this.$content.find('.block__content').spin();
    this.search();
  }
}

module.exports = OrgCategory;
